import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { marginLeft, paddingLeft, paddingRight } from 'utils';
import { FormHelperText } from '@mui/material';

export const StyledUiTreeSelect = styled(DropdownTreeSelect)(
  () => css`
    direction: rtl;

    &.error {
      .dropdown-trigger {
        border: 1px solid #d32f2f !important;
      }
    }

    .dropdown {
      * {
        box-sizing: border-box;
      }

      &-trigger {
        width: 244px;
        height: 44px;
        border-radius: 6px;
        border: solid 1px #eee !important;
        background-color: #fff;
        display: flex !important;
        box-sizing: border-box;
        overflow: hidden !important;
        display: flex;
        ${paddingLeft('12px !important')}
        ${paddingRight('16px !important')}
        align-items: center;

        .tag-list {
          display: flex;
          flex-grow: 1;
          width: 90%;

          .tag-item {
            display: flex;
            flex-grow: 1;
            width: 100%;

            .tag {
              background-color: transparent;
              border: none;
              text-wrap: nowrap;
              text-overflow: ellipsis;
              width: 100%;
              overflow: hidden;
              .tag-remove {
                display: none;
              }
            }
          }
        }

        &.arrow:after {
          font-family: 'remixicon' !important;
          font-style: normal;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          font-size: 1.1rem !important;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #9caebb !important;
        }

        &.arrow.bottom:after {
          content: '\\ea4f' !important;
        }

        &.arrow.top:after {
          content: '\\ea55' !important;
        }
      }

      &-content {
        width: 100%;
        .search {
          border-bottom: 1px solid #eee;
          padding: 8px 12px;
          font-size: 14px;
          line-height: 1.43;
        }

        .infinite-scroll-component {
          height: auto;
          overflow: auto;
          min-height: 100px;
          max-height: 230px;
          overflow-x: hidden !important;
          padding: 0 16px;

          .node {
            padding-top: 10px;
            padding-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            ${paddingLeft('0 !important')}

            .toggle {
              display: inline-flex;
              width: 20px;
              min-width: 20px;
              height: 20px;
              align-items: center;
              justify-content: center;
              border: 2px solid #aaaaaa;
              border-radius: 4px;
              font-size: 1.4rem;
              margin: 0;
              ${paddingRight('4px')}
              color: #092335;
              padding: 0;
              ${marginLeft('8px')}

              &:after {
                margin-top: -1.5px;
                font-style: normal;
              }
            }

            label {
              width: 100%;
              align-items: center;
              justify-content: center;
              display: flex;
            }

            .radio-item {
              display: none;
            }

            .node-label {
              overflow: hidden;
              text-overflow: ellipsis;
              width: 100%;
              display: inline-block;
              font-size: 14px;
              line-height: 1.43;
              color: #222;
            }

            &.leaf {
              .toggle {
                display: none;
              }
            }

            &.focused {
              background-color: transparent;
            }
          }
        }

        .no-matches {
          padding: 8px 12px;
          display: inline-block;
        }

        li[aria-level] {
          padding: 0;
        }

        li[aria-level='2'] {
          ${paddingRight('20px')}
        }

        li[aria-level='3'] {
          ${paddingRight('40px')}
        }

        li[aria-level='4'] {
          ${paddingRight('60px')}
        }

        li[aria-level='5'] {
          ${paddingRight('80px')}
        }

        li[aria-level='6'] {
          ${paddingRight('100px')}
        }

        li[aria-level='7'] {
          ${paddingRight('120px')}
        }

        li[aria-level='8'] {
          ${paddingRight('140px')}
        }

        li[aria-level='9'] {
          ${paddingRight('160px')}
        }

        li[aria-level='10'] {
          ${paddingRight('180px')}
        }
      }
    }
  `
);

export const StyledFormHelper = styled(FormHelperText)(
  () => css`
    color: #d32f2f;
    margin: 3px 5px 0;
    display: inline;
    font-size: 0.625rem;
    text-align: right;
    font-family: inherit !important;
  `
);
